import fp from 'lodash/fp';
import { useState, useCallback } from 'react';
import { rawRequest, contentTypeJson } from '@factorin/rest';
import { config } from '@factorin/container.macro';

import { wrapRequest } from 'Modules/core/api';
import { useSelector } from 'Modules/core/redux';


export const useRequest = <TValues = any, TResult = any>(
    path: string,
    mapFormValuesToApi: (data: TValues) => any,
    method?: string,
    onSuccess?: (data: TValues, result: TResult) => void,
    onError?: (error: any) => void,
) => {
    const [busy, setBusy] = useState(false);

    const clientofficeUrl = useSelector<string>('config.clientofficeUrl');
    const request = useCallback(
        async (data: TValues) => {
            if (busy)
                return;

            setBusy(true);
            const requestUrl = fp.pipe(fp.compact, fp.join(''))([
                clientofficeUrl || config.basePath,
                'api/v1',
                path,
            ]);

            try {
                const result: TResult = await wrapRequest(rawRequest, {
                    method: method || 'POST',
                    url: requestUrl,
                    headers: {
                        Accept: contentTypeJson,
                        'Accept-Language': 'ru',
                        'Content-Type': contentTypeJson,
                    },
                    withCredentials: true,
                    data: JSON.stringify(mapFormValuesToApi(data)),
                });

                if (onSuccess)
                    onSuccess(data, result);
            } catch (error) {
                setBusy(false);
                if (onError)
                    onError(error);
            }
        },
        [busy, clientofficeUrl, path, method, mapFormValuesToApi, onSuccess, onError],
    );

    return {
        busy,
        request,
    };
};
